(function($){
    $(function(){
        var $searchList = $('.zn-search-list');

        if ($searchList.length) {
            $searchList.each(function(){
                var $this = $(this),
                    thisID = $this.attr('id'),
                    $list = $this.find('ul'),
                    list = new List(thisID, { 
                        valueNames: ['zn-li-link'],
                        searchDelay: 200
                    }),
                    totali = list.size(),
                    resultsNote = $this.find('.zn-results-note');

                list.on('searchComplete', function(){
                    var currenti = $list.children('li').length;

                    if (currenti == 0) {
                        resultsNote.html('<p>No results found</p>');
                    } else if (currenti != totali) {
                        resultsNote.html('<p>Displaying '+currenti+' of '+totali+' results</p>');
                    } else {
                        resultsNote.empty();
                    }
                });
            });
        }
    });
})($JQ);